import { twMerge } from 'tailwind-merge';
import type { Icon } from '@phosphor-icons/react';
import { complianceClass, type ComplianceStop } from 'src/features/reporting/utils/color';
import Pill from './Pill';

const ICON_SIZE = { sm: 11, md: 12, lg: 14 } as const;

interface CompliancePillProps {
  text: string;
  stop: ComplianceStop;
  icon?: Icon;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  tooltip?: string;
  onClick?: () => void;
}

export default function CompliancePill({
  text,
  stop,
  icon: IconCmp,
  size = 'sm',
  className,
  tooltip,
  onClick
}: CompliancePillProps) {
  return (
    <Pill
      size={size}
      tooltip={tooltip}
      onClick={onClick}
      className={twMerge('gap-1', complianceClass(stop), className)}
    >
      {IconCmp && <IconCmp size={ICON_SIZE[size]} weight="light" className="shrink-0" />}
      {text}
    </Pill>
  );
}
